/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Kpi,
    KpiFromJSON,
    KpiToJSON,
} from '../models/Kpi';
import {
    type KpiResponse,
    KpiResponseFromJSON,
    KpiResponseToJSON,
} from '../models/KpiResponse';
import {
    type Portfolio,
    PortfolioFromJSON,
    PortfolioToJSON,
} from '../models/Portfolio';
import {
    type PortfolioResponse,
    PortfolioResponseFromJSON,
    PortfolioResponseToJSON,
} from '../models/PortfolioResponse';
import {
    type SegmentResponse,
    SegmentResponseFromJSON,
    SegmentResponseToJSON,
} from '../models/SegmentResponse';

export interface CreatePortfolioRequest {
    portfolio: Portfolio;
}

export interface DeleteAllAccounts1Request {
    id: string;
}

export interface DeletePortfolioRequest {
    id: string;
}

export interface GetKpisRequest {
    id: string;
}

export interface GetPortfolioRequest {
    id: string;
}

export interface GetPortfolioByYearPhaseAndPeriodRequest {
    uwyear: number;
    phase: GetPortfolioByYearPhaseAndPeriodPhaseEnum;
    period: GetPortfolioByYearPhaseAndPeriodPeriodEnum;
}

export interface GetSegmentsRequest {
    id: string;
}

export interface QueryPortfoliosRequest {
    uwyear?: number;
    phase?: QueryPortfoliosPhaseEnum;
    period?: QueryPortfoliosPeriodEnum;
}

export interface UpdateKpi1Request {
    id: string;
    lobKey: string;
    officeKey: string;
    kpi: Array<Kpi>;
}

export interface UpdatePortfolioRequest {
    id: string;
    portfolio: Portfolio;
}

/**
 * 
 */
export class PortfolioApi extends runtime.BaseAPI {

    /**
     * Creates request options for createPortfolio without sending the request
     */
    async createPortfolioRequestOpts(requestParameters: CreatePortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolio'] == null) {
            throw new runtime.RequiredError(
                'portfolio',
                'Required parameter "portfolio" was null or undefined when calling createPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioToJSON(requestParameters['portfolio']),
        };
    }

    /**
     */
    async createPortfolioRaw(requestParameters: CreatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        const requestOptions = await this.createPortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     */
    async createPortfolio(requestParameters: CreatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.createPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAllAccounts1 without sending the request
     */
    async deleteAllAccounts1RequestOpts(requestParameters: DeleteAllAccounts1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAllAccounts1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/account/delete`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAllAccounts1Raw(requestParameters: DeleteAllAccounts1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAllAccounts1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAllAccounts1(requestParameters: DeleteAllAccounts1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllAccounts1Raw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deletePortfolio without sending the request
     */
    async deletePortfolioRequestOpts(requestParameters: DeletePortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deletePortfolioRaw(requestParameters: DeletePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePortfolio(requestParameters: DeletePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllPortfolios without sending the request
     */
    async getAllPortfoliosRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllPortfoliosRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Portfolio>>> {
        const requestOptions = await this.getAllPortfoliosRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioFromJSON));
    }

    /**
     */
    async getAllPortfolios(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Portfolio>> {
        const response = await this.getAllPortfoliosRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKpis without sending the request
     */
    async getKpisRequestOpts(requestParameters: GetKpisRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getKpis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/kpi`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKpisRaw(requestParameters: GetKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        const requestOptions = await this.getKpisRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     */
    async getKpis(requestParameters: GetKpisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getKpisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolio without sending the request
     */
    async getPortfolioRequestOpts(requestParameters: GetPortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPortfolioRaw(requestParameters: GetPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        const requestOptions = await this.getPortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     */
    async getPortfolio(requestParameters: GetPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.getPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPortfolioByYearPhaseAndPeriod without sending the request
     */
    async getPortfolioByYearPhaseAndPeriodRequestOpts(requestParameters: GetPortfolioByYearPhaseAndPeriodRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uwyear'] == null) {
            throw new runtime.RequiredError(
                'uwyear',
                'Required parameter "uwyear" was null or undefined when calling getPortfolioByYearPhaseAndPeriod().'
            );
        }

        if (requestParameters['phase'] == null) {
            throw new runtime.RequiredError(
                'phase',
                'Required parameter "phase" was null or undefined when calling getPortfolioByYearPhaseAndPeriod().'
            );
        }

        if (requestParameters['period'] == null) {
            throw new runtime.RequiredError(
                'period',
                'Required parameter "period" was null or undefined when calling getPortfolioByYearPhaseAndPeriod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/year/{uwyear}/phase/{phase}/period/{period}`;
        urlPath = urlPath.replace('{uwyear}', encodeURIComponent(String(requestParameters['uwyear'])));
        urlPath = urlPath.replace('{phase}', encodeURIComponent(String(requestParameters['phase'])));
        urlPath = urlPath.replace('{period}', encodeURIComponent(String(requestParameters['period'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPortfolioByYearPhaseAndPeriodRaw(requestParameters: GetPortfolioByYearPhaseAndPeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        const requestOptions = await this.getPortfolioByYearPhaseAndPeriodRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     */
    async getPortfolioByYearPhaseAndPeriod(requestParameters: GetPortfolioByYearPhaseAndPeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.getPortfolioByYearPhaseAndPeriodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSegments without sending the request
     */
    async getSegmentsRequestOpts(requestParameters: GetSegmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSegments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/segment`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSegmentsRaw(requestParameters: GetSegmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SegmentResponse>>> {
        const requestOptions = await this.getSegmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SegmentResponseFromJSON));
    }

    /**
     */
    async getSegments(requestParameters: GetSegmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SegmentResponse>> {
        const response = await this.getSegmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for queryPortfolios without sending the request
     */
    async queryPortfoliosRequestOpts(requestParameters: QueryPortfoliosRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['uwyear'] != null) {
            queryParameters['uwyear'] = requestParameters['uwyear'];
        }

        if (requestParameters['phase'] != null) {
            queryParameters['phase'] = requestParameters['phase'];
        }

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/query`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async queryPortfoliosRaw(requestParameters: QueryPortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PortfolioResponse>>> {
        const requestOptions = await this.queryPortfoliosRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioResponseFromJSON));
    }

    /**
     */
    async queryPortfolios(requestParameters: QueryPortfoliosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PortfolioResponse>> {
        const response = await this.queryPortfoliosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateKpi1 without sending the request
     */
    async updateKpi1RequestOpts(requestParameters: UpdateKpi1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateKpi1().'
            );
        }

        if (requestParameters['lobKey'] == null) {
            throw new runtime.RequiredError(
                'lobKey',
                'Required parameter "lobKey" was null or undefined when calling updateKpi1().'
            );
        }

        if (requestParameters['officeKey'] == null) {
            throw new runtime.RequiredError(
                'officeKey',
                'Required parameter "officeKey" was null or undefined when calling updateKpi1().'
            );
        }

        if (requestParameters['kpi'] == null) {
            throw new runtime.RequiredError(
                'kpi',
                'Required parameter "kpi" was null or undefined when calling updateKpi1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/kpi/{lobKey}/{officeKey}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{lobKey}', encodeURIComponent(String(requestParameters['lobKey'])));
        urlPath = urlPath.replace('{officeKey}', encodeURIComponent(String(requestParameters['officeKey'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['kpi']!.map(KpiToJSON),
        };
    }

    /**
     */
    async updateKpi1Raw(requestParameters: UpdateKpi1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Kpi>>> {
        const requestOptions = await this.updateKpi1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiFromJSON));
    }

    /**
     */
    async updateKpi1(requestParameters: UpdateKpi1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Kpi>> {
        const response = await this.updateKpi1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePortfolio without sending the request
     */
    async updatePortfolioRequestOpts(requestParameters: UpdatePortfolioRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePortfolio().'
            );
        }

        if (requestParameters['portfolio'] == null) {
            throw new runtime.RequiredError(
                'portfolio',
                'Required parameter "portfolio" was null or undefined when calling updatePortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioToJSON(requestParameters['portfolio']),
        };
    }

    /**
     */
    async updatePortfolioRaw(requestParameters: UpdatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Portfolio>> {
        const requestOptions = await this.updatePortfolioRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioFromJSON(jsonValue));
    }

    /**
     */
    async updatePortfolio(requestParameters: UpdatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Portfolio> {
        const response = await this.updatePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPortfolioByYearPhaseAndPeriodPhaseEnum = {
    Planning: 'Planning',
    Tiering: 'Tiering',
    Tracking: 'Tracking'
} as const;
export type GetPortfolioByYearPhaseAndPeriodPhaseEnum = typeof GetPortfolioByYearPhaseAndPeriodPhaseEnum[keyof typeof GetPortfolioByYearPhaseAndPeriodPhaseEnum];
/**
 * @export
 */
export const GetPortfolioByYearPhaseAndPeriodPeriodEnum = {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
    Hy: 'HY'
} as const;
export type GetPortfolioByYearPhaseAndPeriodPeriodEnum = typeof GetPortfolioByYearPhaseAndPeriodPeriodEnum[keyof typeof GetPortfolioByYearPhaseAndPeriodPeriodEnum];
/**
 * @export
 */
export const QueryPortfoliosPhaseEnum = {
    Planning: 'Planning',
    Tiering: 'Tiering',
    Tracking: 'Tracking'
} as const;
export type QueryPortfoliosPhaseEnum = typeof QueryPortfoliosPhaseEnum[keyof typeof QueryPortfoliosPhaseEnum];
/**
 * @export
 */
export const QueryPortfoliosPeriodEnum = {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
    Hy: 'HY'
} as const;
export type QueryPortfoliosPeriodEnum = typeof QueryPortfoliosPeriodEnum[keyof typeof QueryPortfoliosPeriodEnum];
